// extracted by mini-css-extract-plugin
export default {"mainContainer":"Info_mainContainer__zSrq6","row":"Info_row__SX7ip","fontSize":"Info_fontSize__9Kcgu","title":"Info_title__hm5he"};